import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["label", "drawer"]
  static values = { mobileOpen: Boolean }

  connect() {
    this.mobileOpenValue = false

    // Create overlay element for mobile
    this.overlay = document.createElement('div')
    this.overlay.className = 'fixed inset-0 bg-black/50 z-30 hidden'
    this.overlay.addEventListener('click', () => this.closeMobile())
    document.body.appendChild(this.overlay)
  }

  disconnect() {
    if (this.overlay) {
      this.overlay.remove()
    }
  }

  toggleMobile() {
    if (this.mobileOpenValue) {
      this.closeMobile()
    } else {
      this.openMobile()
    }
  }

  openMobile() {
    if (!this.hasDrawerTarget) return

    this.mobileOpenValue = true
    this.drawerTarget.classList.remove('-translate-x-full')
    this.drawerTarget.classList.add('translate-x-0')
    this.labelTargets.forEach(label => label.classList.remove("hidden"))
    this.overlay.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  closeMobile() {
    if (!this.hasDrawerTarget) return

    this.mobileOpenValue = false
    this.drawerTarget.classList.remove('translate-x-0')
    this.drawerTarget.classList.add('-translate-x-full')
    this.labelTargets.forEach(label => {
      label.classList.add("hidden")
      label.classList.add("md:group-hover:block")
    })
    this.overlay.classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
  }
}
